<template>
  <div class="content">
    <div class="agreement-container" v-html="agreementInfo"></div>
    <div v-if="needRead" class="main-btn-box">
      <div class="main-btn" :class="[countDown > 0 ? 'disable' : '']" @click="onConfirm">我已详细阅读并同意以上内容<span v-if="countDown > 0">（{{countDown}}s）</span></div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { reactive, ref, onMounted, getCurrentInstance,computed } from 'vue';
  import logger from '@utils/logger';
  import { agreementInfoApi } from '@/api/agreement';
  import { parseQuery } from '@utils/utils';
	const { proxy } = getCurrentInstance() as any

  const query = parseQuery()
  const agreementInfo = ref<any>('')
  const needRead = ref<boolean>(false)
  const getAgreementInfo = async () => {
    try {
      const res = await agreementInfoApi({
        agreementId: query?.id || ''
      })
      if(res?.code === 0) {
        agreementInfo.value = res?.data?.content || ''
        let cd = res?.data?.countDown || 0
        if(query?.noCountdown){
          cd = 0
        }
        if(cd){
          needRead.value = true
          countDown.value = cd
          startCountDown()
        }
      }
    } catch (error) {
      console.log('获取协议内容error:', error)
    }
  }
  onMounted(() => {
    getAgreementInfo()
  })

  const countDown = ref(0)
  let timer: any = null
  function startCountDown(){
    timer = setInterval(() => {
      if(countDown.value > 0) {
        countDown.value = countDown.value - 1
      }else {
        clearInterval(timer)
      }
    }, 1000)
  }
  function onConfirm(){
    if(countDown.value > 0) return
    proxy.$wx.miniProgram.postMessage({
      data: {
        event: 'set-page-data',
        type:'set-page-data',
        from: 'agreement',
        agreementId: query?.id || '',
        readAgreement: 1
      }
    })
    proxy.$wx.miniProgram.navigateBack({delta: 1})
  }
</script>
<style scoped lang="scss">
.agreement-container {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  word-break: break-all;
  overflow-wrap: break-word;
}
.content {
  padding: 20px;
  padding-bottom: 200px;
}
.main-btn-box {
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: calc(100% - 40px);
  padding: 20px;
  .main-btn {
    padding: 20rpx;
    width: 100%;
    padding: 28px 0;
    border-radius: 56px;
    background: linear-gradient(315deg, #FF211A 0%, #FF4C41 72.4%, #FF958F 100%);
    color: #FFF;
    text-align: center;
    font-family: PingFang SC;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px; /* 100% */
    border: 0;
  }
  .main-btn.disable {
    opacity: 0.3;
  }
}
</style>
